import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4c5ac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-settings-topbar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-title" }, "⚙️ Settings", -1 /* HOISTED */))
const _hoisted_3 = { class: "nge-settings-content" }
const _hoisted_4 = { class: "nge-settings-section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-settings-label" }, "Country / Flag", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Pick your country or the EyeWire logo.", -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-settings-country-flag-cell" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "nge-settings-country-flag-placeholder"
}
const _hoisted_11 = { class: "nge-settings-country-name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-country-caret" }, "▾", -1 /* HOISTED */))
const _hoisted_13 = {
  key: 0,
  class: "nge-settings-country-dropdown"
}
const _hoisted_14 = { class: "nge-settings-country-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "nge-settings-country-opt-flag" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "nge-settings-country-opt-name" }
const _hoisted_20 = {
  key: 0,
  class: "nge-settings-country-empty"
}
const _hoisted_21 = { class: "nge-settings-section" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-settings-label" }, "Bio", -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Share a little about yourself with the community.", -1 /* HOISTED */))
const _hoisted_24 = { class: "nge-settings-section" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-settings-label" }, "Toolbar Icons", -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Toggle which actions appear in your top bar.", -1 /* HOISTED */))
const _hoisted_27 = { class: "nge-settings-toolbar-grid" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = {
  key: 2,
  class: "nge-settings-toolbar-emoji"
}
const _hoisted_32 = { class: "nge-settings-toolbar-label" }
const _hoisted_33 = { class: "nge-settings-section" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-settings-label" }, "Notifications", -1 /* HOISTED */))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Control the badges on your toolbar icons.", -1 /* HOISTED */))
const _hoisted_36 = { class: "nge-settings-toggle" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Mute chat unread badge", -1 /* HOISTED */))
const _hoisted_38 = { class: "nge-settings-toggle" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Mute help requests", -1 /* HOISTED */))
const _hoisted_40 = { class: "nge-settings-toggle" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-settings-toggle-label" }, "Always show scout tags on cells", -1 /* HOISTED */))
const _hoisted_42 = { class: "nge-settings-section" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-settings-label" }, "Advanced", -1 /* HOISTED */))
const _hoisted_44 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, "Active logins:", -1 /* HOISTED */))
const _hoisted_46 = { class: "nge-settings-login-info" }
const _hoisted_47 = { class: "nge-settings-login-email" }
const _hoisted_48 = { class: "nge-settings-login-host" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "nge-settings-section" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-settings-label" }, "Username", -1 /* HOISTED */))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-settings-hint" }, " How you appear in chat, and how others tag you. 3-20 characters, letters/numbers/underscore, no spaces. ", -1 /* HOISTED */))
const _hoisted_53 = { class: "nge-settings-username-display" }
const _hoisted_54 = { class: "nge-settings-actions" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.props.embedded ? 'div' : $setup.ModalOverlay), {
    id: $setup.props.embedded ? undefined : 'nge-settings-modal',
    class: _normalizeClass($setup.props.embedded ? 'nge-settings-embedded' : 'nge-settings-modal'),
    onHide: _cache[10] || (_cache[10] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["nge-settings-shell", { 'nge-settings-shell--embedded': $setup.props.embedded }])
      }, [
        _createCommentVNode(" Top bar "),
        (!$setup.props.embedded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("button", {
                class: "nge-settings-exit",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
              }, "×")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Settings content "),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", {
              id: "nge-settings-country-wrap",
              class: "nge-settings-country-wrap",
              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("button", {
                class: "nge-settings-country-btn",
                onClick: _cache[1] || (_cache[1] = $event => ($setup.showCountryList = !$setup.showCountryList))
              }, [
                _createElementVNode("span", _hoisted_7, [
                  ($setup.draftFlag === 'eyewire')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $setup.pyrIcon,
                        class: "nge-settings-country-flag-img nge-settings-country-flag-img--logo"
                      }, null, 8 /* PROPS */, _hoisted_8))
                    : ($setup.flagImgUrl($setup.draftFlag))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: $setup.flagImgUrl($setup.draftFlag),
                          class: "nge-settings-country-flag-img"
                        }, null, 8 /* PROPS */, _hoisted_9))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "🌐"))
                ]),
                _createElementVNode("span", _hoisted_11, _toDisplayString($setup.selectedCountry?.name || 'Choose a country'), 1 /* TEXT */),
                _hoisted_12
              ]),
              ($setup.showCountryList)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.countrySearch) = $event)),
                      type: "text",
                      class: "nge-settings-country-search",
                      placeholder: "Search country...",
                      autocomplete: "off",
                      spellcheck: "false",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, $setup.countrySearch]
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCountries, (c) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: c.code,
                          class: _normalizeClass(["nge-settings-country-opt", { 'nge-settings-country-opt--active': $setup.draftFlag === c.code }]),
                          onClick: $event => ($setup.selectCountry(c.code))
                        }, [
                          _createElementVNode("span", _hoisted_16, [
                            (c.code === 'eyewire')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: $setup.pyrIcon,
                                  class: "nge-settings-country-flag-img nge-settings-country-flag-img--logo"
                                }, null, 8 /* PROPS */, _hoisted_17))
                              : ($setup.flagImgUrl(c.code))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: $setup.flagImgUrl(c.code),
                                    class: "nge-settings-country-flag-img"
                                  }, null, 8 /* PROPS */, _hoisted_18))
                                : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(c.name), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_15))
                      }), 128 /* KEYED_FRAGMENT */)),
                      ($setup.filteredCountries.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, "No matches"))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.draftBio) = $event)),
              class: "nge-settings-textarea",
              maxlength: "280",
              rows: "4",
              placeholder: "e.g. PhD student at MIT. Loves connectomics and cold brew."
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.draftBio]
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-settings-charcount", { 'nge-settings-charcount--warn': $setup.draftBio.length > 250 }])
            }, _toDisplayString($setup.draftBio.length) + " / 280", 3 /* TEXT, CLASS */)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.TOOLBAR_ICON_OPTIONS, (opt) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: opt.id,
                  class: _normalizeClass(["nge-settings-toolbar-item", { 'nge-settings-toolbar-item--active': $setup.isToolbarIconEnabled(opt.id) }]),
                  onClick: $event => ($setup.toggleToolbarIcon(opt.id))
                }, [
                  (opt.svg)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "nge-settings-toolbar-emoji",
                        innerHTML: opt.svg
                      }, null, 8 /* PROPS */, _hoisted_29))
                    : (opt.img)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: opt.img,
                          class: "nge-settings-toolbar-icon-img",
                          alt: opt.label
                        }, null, 8 /* PROPS */, _hoisted_30))
                      : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(opt.emoji), 1 /* TEXT */)),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(opt.label), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_28))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("button", {
              class: "nge-settings-toolbar-reset",
              onClick: $setup.resetToolbar
            }, "Reset to defaults")
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _hoisted_35,
            _createElementVNode("label", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.draftChatMuted) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, $setup.draftChatMuted]
              ]),
              _hoisted_37
            ]),
            _createElementVNode("label", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.draftHelpMuted) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, $setup.draftHelpMuted]
              ]),
              _hoisted_39
            ]),
            _createElementVNode("label", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.draftShowScoutTags) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, $setup.draftShowScoutTags]
              ]),
              _hoisted_41
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", { style: {"display":"grid","grid-template-columns":"repeat(2, 1fr)","gap":"8px"} }, [
              _createElementVNode("button", {
                class: "nge-settings-advanced-btn",
                onClick: $setup.openNgSettings
              }, "⚙ Viewer Settings"),
              _createElementVNode("button", {
                class: "nge-settings-advanced-btn",
                onClick: $setup.openJsonEditor
              }, "{} Edit JSON State"),
              _createElementVNode("button", {
                class: "nge-settings-advanced-btn",
                onClick: $setup.toggleLayerListPanel
              }, "☰ Layer List Panel"),
              _createElementVNode("button", {
                class: "nge-settings-advanced-btn",
                onClick: $setup.toggleSelectionDetails
              }, "◫ Selection Details")
            ]),
            _createCommentVNode(" Logins management "),
            ($setup.loginStore.sessions.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.loginStore.sessions, (session) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: session.hostname,
                      class: "nge-settings-login-row"
                    }, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", _hoisted_47, _toDisplayString(session.email || 'Unknown'), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_48, _toDisplayString(session.hostname), 1 /* TEXT */)
                      ]),
                      _createElementVNode("button", {
                        class: "nge-settings-logout-btn",
                        onClick: $event => ($setup.logoutSession(session))
                      }, "Logout", 8 /* PROPS */, _hoisted_49)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createCommentVNode(" Username lives at the bottom and is deliberately NOT an always-live\n             text field: it's how everyone tags you, so changing it should be a\n             deliberate act. Show the current handle read-only; the actual edit\n             happens in the dedicated dialog (validation + availability check),\n             opened by the button. `force` bypasses the dialog's \"ask once\"\n             guards so it works when you already have a handle. "),
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("span", {
                class: _normalizeClass(["nge-settings-username-current", { 'nge-settings-username-current--empty': !$setup.backendStore.username }])
              }, _toDisplayString($setup.backendStore.username ? '@' + $setup.backendStore.username : 'No username set yet'), 3 /* TEXT, CLASS */),
              _createElementVNode("button", {
                class: "nge-settings-username-btn",
                onClick: $setup.openUsernameDialog
              }, _toDisplayString($setup.backendStore.username ? 'Change username…' : 'Pick a username…'), 1 /* TEXT */)
            ])
          ])
        ]),
        _createCommentVNode(" Pinned footer: moved OUT of .nge-settings-content so Save stays\n           reachable on short screens. Previously it scrolled with the body,\n           and on a small laptop the whole panel simply overflowed the viewport\n           with no scrollbar, putting Save off-screen entirely. "),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("button", {
            class: "nge-settings-save",
            onClick: $setup.handleSave
          }, [
            ($setup.saved)
              ? (_openBlock(), _createElementBlock("span", _hoisted_55, "✓ Saved!"))
              : (_openBlock(), _createElementBlock("span", _hoisted_56, "Save"))
          ]),
          (!$setup.props.embedded)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "nge-settings-cancel",
                onClick: _cache[9] || (_cache[9] = $event => ($setup.emit('hide')))
              }, "Cancel"))
            : _createCommentVNode("v-if", true)
        ])
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 40 /* PROPS, HYDRATE_EVENTS */, ["id", "class"]))
}